var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeroFullCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M50.3706 25C50.3706 38.8071 39.1777 50 25.3706 50C11.5635 50 0.370605 38.8071 0.370605 25C0.370605 11.1929 11.5635 0 25.3706 0C39.1777 0 50.3706 11.1929 50.3706 25ZM12.8706 25C12.8706 31.9036 18.467 37.5 25.3706 37.5C32.2742 37.5 37.8706 31.9036 37.8706 25C37.8706 18.0964 32.2742 12.5 25.3706 12.5C18.467 12.5 12.8706 18.0964 12.8706 25Z",
    fill: "#05235F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroFullCircle);
export default __webpack_public_path__ + "static/media/hero-full-circle.7cbe49dd09c214f8043b811041557e89.svg";
export { ForwardRef as ReactComponent };